var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 45,
    viewBox: "0 0 35 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.30658 16.7307C5.30658 10.1034 10.6791 4.73098 17.3063 4.73098C23.9335 4.73098 29.306 10.1034 29.306 16.7307V21.0942C29.306 24.6347 30.4543 28.0799 32.5788 30.9123L33.0461 31.5355C33.1169 31.6296 33.152 31.6768 33.174 31.7081C34.2046 33.1833 33.1895 35.2138 31.3908 35.2744C31.3527 35.2758 31.2937 35.2758 31.1762 35.2758H3.4365C3.31885 35.2758 3.26003 35.2758 3.22178 35.2744C1.42322 35.2138 0.408018 33.1833 1.43862 31.7081C1.46054 31.6768 1.49581 31.6296 1.56641 31.5355L2.03392 30.9123C4.15824 28.0799 5.30658 24.6347 5.30658 21.0942V16.7307Z",
    stroke: "white",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0386 39.9573C12.3494 41.1172 13.0342 42.1419 13.9868 42.873C14.9393 43.6039 16.1065 44 17.3072 44C18.5079 44 19.6751 43.6039 20.6276 42.873C21.5804 42.1419 22.265 41.1172 22.5758 39.9573",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0149 4.69131C19.8552 3.6553 19.5031 2.73985 19.0136 2.08693C18.5238 1.43401 17.9238 1.0801 17.3065 1.0801C16.6893 1.0801 16.0892 1.43401 15.5997 2.08693C15.1099 2.73985 14.7579 3.6553 14.5982 4.69131",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.922864aae73cb5c0d881bcd27839a45b.svg";
export { ForwardRef as ReactComponent };